"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var EmbedForm = function EmbedForm(_ref) {
  var _onChange = _ref.onChange,
      _ref$state$url = _ref.state.url,
      url = _ref$state$url === void 0 ? '' : _ref$state$url;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "mb-1"
  }, "Iframe Embed Code"), /*#__PURE__*/_react["default"].createElement("textarea", {
    className: "form-control",
    rows: 6,
    value: url,
    onChange: function onChange(e) {
      return _onChange({
        url: e.target.value
      });
    }
  })));
};

var _default = EmbedForm;
exports["default"] = _default;